import { render, staticRenderFns } from "./DialogEditarConfigSistema.vue?vue&type=template&id=eb2eb628"
import script from "./DialogEditarConfigSistema.vue?vue&type=script&lang=js"
export * from "./DialogEditarConfigSistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports